// @flow
import React, { useState, useEffect } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import "./styles.css";
import { Link } from "react-router-dom";
import Page from "../../components/page";
import TextBox from "../../components/text-box";
import TextBlock from "../../components/text-block";
import Team from "../../models/team";
import Checkbox from "../../components/checkbox";
import DropDown from "../../components/drop-down";
import { search } from "../../libs/utilities";
import queryString from "query-string";
import { MetaData } from "../../components/meta-data";
import { Card } from "../../components/card";
import DateTimePicker from "../../components/date-time-picker";
import Radio from "../../components/radio";
import Time from "../../components/time";
import TeamMap from "../../components/team-map";
import * as teamActions from "../../action-creators/team-actions";
import SearchBar from "../../components/search-bar";
import * as R from "ramda";

type RowPropsType = { id: string, name: string, location: string };
type PropsType = {
    actions: { [string]: any=>void },
    match: Object,
    towns: ?Object,
    trashDrops: ?Object,
    panel: ?Object,
    teams: Object,
    datum: ?Team,
    error: ?string
};

const MyScreen = ({ actions, match, towns, trashDrops, teams }: PropsType) => {

    const [currentTeam, setCurrentTeam] = useState({});
    const handleCurrentTeamChange = R.curry((key, value) => {
        setCurrentTeam({ ...currentTeam, [key]: value });
    });
    const RowTemplate = ({ id, name, location }: RowPropsType): React.Component => (
        <Link className={ "teams--row" } to={ `/teams/${id}${window.location.search}` }>
            <span className="teams--team-name">{name}</span>
            <span className={ "teams--team-location" }>{location}</span>
        </Link>
    );
    const headerContent = (<button className="teams--header-button" onClick={ () => actions.saveTeam(currentTeam) }>{"Save"}</button>);
    const q = queryString.parse(window.location.search);
    const filteredteams = search(teams, q.search);
    const owner = currentTeam.owner || {};
    const members = search(Object.values((currentTeam || {}).members || {}), q.search).map(member => (
        <div className={ "teams--team-member" } key={ member.uid }>
            <TextBox labelText={ "Name" }
                readOnly={ true }
                value={ member.displayName }/>
            <TextBox labelText={ "Email" }
                readOnly={ true }
                value={ member.email }/>
            <TextBox labelText={ "ID" }
                readOnly={ true }
                value={ member.uid }/>
        </div>
    ));
    const teamDrops = Object.values((trashDrops || {}).data || {})
        .filter(drop => Boolean(drop)) // Could be some bad api here :-(
        .filter(drop => (drop.createdBy || {}).uid in (currentTeam.members || {}));


    useEffect(() => {
        if (currentTeam.id !== match.params.id) {
            const nextTeam = (teams || []).find(datum => datum.id === match.params.id) || {};
            setCurrentTeam(R.clone(nextTeam));
        }
    }, [match]);

    return (

        <Page RowTemplate={ RowTemplate }
            data={ filteredteams }
            headerContent={ headerContent }
            pagination={ false }
            toolbar={ (<SearchBar/>) }
        >
            <section className={ "teams" }>
                <MetaData
                    created={ currentTeam.created }
                    id={ currentTeam.id }
                    updated={ currentTeam.updated }
                />
                <Card>
                    <h3>{"Team Details"}</h3>
                    <TextBox labelText={ "Name" }
                        onChange={ handleCurrentTeamChange("name") }
                        value={ currentTeam.name }/>
                    <Checkbox checked={ currentTeam.active }
                        labelText={ "Active" }
                        onChange={ () => handleCurrentTeamChange("active")(!currentTeam.active) }/>

                    <TextBlock isValidating={ false }
                        labelText="Team Description"
                        onChange={ handleCurrentTeamChange("description") }
                        required={ false }
                        value={ currentTeam.description || "" }
                    />
                    <TextBlock isValidating={ false }
                        labelText="Team Notes"
                        onChange={ handleCurrentTeamChange("notes") }
                        required={ false }
                        value={ currentTeam.notes || "" }
                    />

                    <div className={ "teams--is-public" }>
                        <h4>{"Group Type"}</h4>
                        <Radio checked={ currentTeam.isPublic }
                            labelText={ "Public" }
                            onChange={ () => handleCurrentTeamChange("isPublic")(true) }
                        />
                        <Radio checked={ !currentTeam.isPublic }
                            labelText={ "Private" }
                            onChange={ () => handleCurrentTeamChange("isPublic")(false) }
                        />
                    </div>
                </Card>
                <Card>
                    <h3>{"Team Event"}</h3>
                    <DropDown isValidating={ false }
                        labelText="Town"
                        onChange={ handleCurrentTeamChange("town") }
                        placeholder={ "select town" }
                        required={ false }
                        value={ currentTeam.town || "" }>
                        {Object.values(towns || {}).map(town => (<option key={ town.id } value={ town.id }>{town.name}</option>))}
                    </DropDown>
                    <TextBox labelText={ "Location" }
                        onChange={ handleCurrentTeamChange("location") }
                        value={ currentTeam.location }/>
                    <DateTimePicker labelText={ "Date" }
                        onChange={ handleCurrentTeamChange("date") }
                        type={ "date" }
                        value={ currentTeam.date || "" }
                    />
                    <Time labelText={ "Start Time" }
                        onChange={ handleCurrentTeamChange("start") }
                        type={ "time" }
                        value={ currentTeam.start || "" }
                    />
                    <Time labelText={ "End time" }
                        onChange={ handleCurrentTeamChange("end") }
                        type={ "time" }
                        value={ currentTeam.end || "" }
                    />
                </Card>
                <Card>
                    <h3>{"Team Owner"}</h3>
                    <TextBox labelText={ "Name" }
                        readOnly={ true }
                        value={ owner.displayName }/>
                    <TextBox labelText={ "Email" }
                        readOnly={ true }
                        value={ owner.email }/>
                    <TextBox labelText={ "ID" }
                        readOnly={ true }
                        value={ owner.uid }/>
                </Card>
                <Card>
                    <h3>{"Team Map"}</h3>
                    <div className={ "teams--trash-map" }>
                        <TeamMap
                            dropOffLocations={ {} }
                            pickupLocations={ {} }
                            team={ currentTeam }
                            teamDrops={ teamDrops }/>
                    </div>
                </Card>
                <Card>
                    <h3>{"Team Members"}</h3>
                    {members}
                </Card>
            </section>
        </Page>

    );
};


const mapStateToProps = (state: Object): Object => {
    const towns = Object.values((state.towns || {}).data || {});
    const trashDrops = state.trashDrops;
    const teams = Object.values((state.teams || {}).data || {});
    return { towns, trashDrops, teams, currentTeamPage: 1 };
};

const mapDispatchToProps = (dispatch): Object => ({
    actions: bindActionCreators(teamActions, dispatch)
});

export const TeamsScreen = connect(mapStateToProps, mapDispatchToProps)(MyScreen);